var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-item",class:[_vm.currentSelected ? _vm.activeClass : '', {
    'vux-tab-selected': _vm.currentSelected,
    'vux-tab-disabled': _vm.disabled 
  }],style:(_vm.style),on:{"click":_vm.onItemClick}},[_vm._t("default"),_vm._v(" "),(typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '')?_c('span',{staticClass:"vux-tab-item-badge",style:({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })},[_vm._v("\n  "+_vm._s(_vm.badgeLabel))]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57c3c9c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/tab/tab-item.vue
// module id = 626
// module chunks = 46